export default "__VITE_ASSET__4e9a782e__"